<template>
    <div class="web-skill-ranking-container skeleton-mode">
        <el-main class="ranking-content">
            <section class="card ranking-header-section">
                <el-skeleton animated>
                    <template #template>
                        <div class="summary-skeleton-bars">
                            <el-skeleton-item variant="text" style="width: 100%; height: 14px; margin-bottom: 12px;" />
                            <el-skeleton-item variant="text" style="width: 96%; height: 14px; margin-bottom: 12px;" />
                            <el-skeleton-item variant="text" style="width: 98%; height: 14px; margin-bottom: 12px;" />
                            <el-skeleton-item variant="text" style="width: 85%; height: 14px;" />
                        </div>
                    </template>
                </el-skeleton>
            </section>

            <section class="card ranking-table-section">
                <el-skeleton animated>
                    <template #template>
                        <div v-for="i in 5" :key="i" class="table-skeleton-row">
                            <div class="col-position">
                                <el-skeleton-item variant="rect" style="width: 60px; height: 60px; border-radius: 4px;" />
                            </div>
                            <div class="col-avatar">
                                <el-skeleton-item variant="circle" style="width: 60px; height: 60px;" />
                            </div>
                            <div class="col-multiline">
                                <el-skeleton-item variant="text" style="width: 60%; height: 16px; margin-bottom: 6px;" />
                                <el-skeleton-item variant="text" style="width: 80%; height: 14px;" />
                            </div>
                            <div class="col-multiline">
                                <el-skeleton-item variant="text" style="width: 50%; height: 16px; margin-bottom: 6px;" />
                                <el-skeleton-item variant="text" style="width: 70%; height: 14px;" />
                            </div>
                            <div class="col-multiline">
                                <el-skeleton-item variant="text" style="width: 40%; height: 16px; margin-bottom: 6px;" />
                                <el-skeleton-item variant="text" style="width: 60%; height: 14px;" />
                            </div>
                            <div class="col-actions">
                                <el-skeleton-item variant="rect" style="width: 36px; height: 36px; border-radius: 4px;" />
                            </div>
                        </div>
                    </template>
                </el-skeleton>
            </section>
        </el-main>
    </div>
</template>

<script>
export default {
    name: "WebSkillRankingSkeleton",
};
</script>

<style scoped>
.web-skill-ranking-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.skeleton-mode {
    background-color: #f5f7fa;
}

.ranking-content {
    display: flex;
    flex-direction: column;
    padding: 20px;
    flex-grow: 1;
    gap: 20px;
    overflow-y: hidden;
    background: #ededed;
}

.card {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 1.5rem;
}

.ranking-header-section {
    margin-bottom: 0;
}

.header-main-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 2rem;
}

.stats-container {
    display: flex;
    align-items: flex-start;
    gap: 3rem;
    flex: 1;
}

.stat-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.table-skeleton-row {
    display: flex;
    gap: 1rem;
    align-items: center;
    padding: 15px 10px;
    background-color: #ffffff;
    border: 4.5px solid #ededed;
    border-radius: 8px;
    margin-bottom: 8px;
}

.table-skeleton-row:last-child {
    margin-bottom: 0;
}

.col-position {
    width: 80px;
    display: flex;
    justify-content: center;
}

.col-avatar {
    width: 90px;
    display: flex;
    justify-content: center;
}

.col-multiline {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.col-actions {
    width: 80px;
    display: flex;
    justify-content: center;
}
</style>